import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Keeps the activity query fresh by polling at a short interval.
 *
 * Sprint 6.0a's SSE pattern is per-request (JSON-RPC response + notifications),
 * not a standing EventSource channel. Until the worker adds a persistent SSE or
 * WebSocket broadcast for agent_runs.created, we use aggressive refetch polling
 * to approximate live updates within the ~2s target.
 */
export function useSseActivity(filters?: { agentId?: string }) {
  const qc = useQueryClient();

  useEffect(() => {
    const interval = setInterval(() => {
      qc.invalidateQueries({ queryKey: ["v3", "activity"] });
    }, 3_000);

    return () => clearInterval(interval);
  }, [qc, filters?.agentId]);
}
